"use client";

import TermsAndPrivacyNotice from "@/components/auth/shared/TermsAndPrivacyNotice";

type AuthFooterProps = {
  prompt: string;
  actionLabel: string;
  onActionClick: () => void;
  className?: string;
};

const AuthFooter = ({
  prompt,
  actionLabel,
  onActionClick,
  className = "pt-6",
}: AuthFooterProps) => {
  return (
    <div className={className}>
      <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[15px] text-[#898D91] sm:text-base">
        <span>{prompt}</span>
        <button
          type="button"
          onClick={onActionClick}
          className="font-semibold text-[#0B9BFF] hover:underline"
        >
          {actionLabel}
        </button>
      </p>

      <TermsAndPrivacyNotice
        prefix="By signing in or registering, you are deemed to have agreed to Tovtrip's"
        className="mx-auto mt-4 text-left text-[12px] leading-[17px] text-[#898D91] sm:mt-5 sm:text-[13px] sm:leading-[18px]"
        linkClassName="font-medium"
      />
    </div>
  );
};

export default AuthFooter;
